import * as React from "react";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { Div } from "../../../../react-core/Html/Div";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { ITableConfig, Table } from "../../../Shared/Table/Table";

interface ICommentsAndDocumentsResultTable {
    data: any;
    onPageChange: (currentPage, pageSize) => void;
    usingInTools?: (row) => void;
    errorMsg?: string;
}

export const CommentsAndDocumentsResultTable = (props: ICommentsAndDocumentsResultTable) => {
    if (!props.data) {return null;}

    const [currentPage, setCurrentPage] = React.useState(1);

    const col: ITableConfig[] = [
        {
            title: "Policy number",
            key: "PolicyNumber",
        },
        {
            title: "Demand type",
            key: "DemandType",
        },
        {
            title: "Date",
            key: "UpdatedDate",
            render: (data) => {
                return JsonDateParser.getFormatDateString(JsonDateParser.toDate(data), "dd-MM-yyyy hh:mm:ss");
            },
        },
        {
            title: "Type",
            key: "Type",
        },
        {
            title: "Unique Id",
            key: "UniqueId",
        },
        {
            title: "Data",
            key: "Data",
            render: (data) => {
                return CommonHelper.RemoveHtmlTag(CommonHelper.ReplaceSpecialSymbols(data));
            },
        },
    ];

    return (
        <>
            <hr />
            <Table
                data={props.data.PageOfResults}
                col={col}
                showEmptyMsg
                emptyMsg={props.errorMsg}
                cssWrapper="mb-60"
                needPagination={{
                    totalNumOfResult: props.data.TotalNumberOfResults,
                    onPaginationChange: (pageIndex, pageSize) => {
                        setCurrentPage(pageIndex);
                        props.onPageChange(pageIndex, pageSize);
                    },
                    currentPage: currentPage,
                }}
            />
        </>
    );
};
